import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EndpointAdvancedVisibilityProps {
  onSubmit: () => void;
  endpointNode: string;
  proxying_enabled?: boolean;
}
export const EndpointAdvancedVisibility = ({
  onSubmit,
  endpointNode,
  proxying_enabled,
}: EndpointAdvancedVisibilityProps) => {
  const api = useApi();
  const [visible, setVisible] = React.useState(proxying_enabled || false);
  const [disableSubmit, setDisableSubmit] = React.useState(true);

  const handleVisibleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVisible(e.target.checked);
    setDisableSubmit(e.target.checked === proxying_enabled);
  };

  const epResize = useMutation(api.configureEndpointProxyingApiV1ConfigureEndpointProxyingPost, {
    onSuccess() {
      toast.success('Configured visibility successfully.');
      onSubmit();
    },
    onError: (error) => {
      apiError(error);
      setDisableSubmit(false);
    },
  });

  const handleSubmit = () => {
    setDisableSubmit(true);
    epResize.mutate({
      ep_id: endpointNode,
      enabled: visible || false
    });
  };

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
        Advanced visibility allows you to monitor TCP session qualities such as TCP retransmission counts.
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControlLabel
          value="top"
          control={
            <Switch color="primary" checked={visible} onChange={handleVisibleChange} />
          }
          label={visible ? 'Enabled' : 'Disabled'}
          labelPlacement="bottom"
          sx={(theme) => ({ '&:hover': { color: theme.palette.primary.main } })}
          componentsProps={{
            typography: {
              sx: (theme) => ({
                fontSize: 12,
                color: !visible ? theme.palette.grey[600] : theme.palette.primary.main,
              }),
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={disableSubmit}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
